module.exports = __webpack_public_path__ + "static/img/sc.d81b5a2c.png";